import { NamedBindings, UserServiceInterface } from "@dandelion/core";
import { inject, injectable } from "inversify";
import { ComputedRef, computed, ref } from "vue";

@injectable()
export class YearService {
  protected selectedYear = ref(new Date().getFullYear());
  protected admissionYear = ref(new Date().getFullYear());
  constructor(
    @inject(NamedBindings.UserService) protected userService: UserServiceInterface
  ) {
    this.selectedYear.value = new Date().getFullYear();
  }

  setAdmissionYear(year: number) {
    this.admissionYear.value = year;
  }

  setSelectedYear(year: number) {
    this.selectedYear.value = year;
  }

  getSelectedYear() {
    return this.selectedYear.value;
  }

  getAdmissionYear() {
    return this.admissionYear.value;
  }

  public getCentreCodeWithSelectedYear(): ComputedRef<string> {
    const centreCode = this.userService.getCurrentUser()?.value?.centre || '*';
    const admissionYear = this.getAdmissionYear();
    if (this.selectedYear.value != admissionYear) {
      this.selectedYear.value = admissionYear;
    }
    return computed(() => `${centreCode}_${this.selectedYear.value}`);
  }

  public getCentreCodeWithPreviousYear(): ComputedRef<string | null> {
    const currentYear = new Date().getFullYear();
    const centreCode = this.userService.getCurrentUser()?.value?.centre || '*';

    if (this.selectedYear.value === currentYear) {
      const lastYear = currentYear - 1;
      return computed(() => `${centreCode}_${lastYear}`);
    }
    return computed(() => null);
  }

  public getCentreCodeWithAdmissionYear(): ComputedRef<string> {
    const centreCode = this.userService.getCurrentUser()?.value?.centre || '*';
    return computed(() => `${centreCode}_${this.admissionYear.value}`);
  }
}